export function getValueAndParse(key, defaultValue = '', cb = v => v) {
  let value = localStorage.getItem(key)
  if (value !== null) {
    value = JSON.parse(value)
    value = cb(value)
    return value
  }
  return defaultValue
}
